import './Loader.scss'

const PreLoad = () => {
  return (
    <div className='loader'>
      <span>zizu</span>
    </div>
  )
}

export default PreLoad